<!-- TODO
<template>
  <div class="download">
    <button
      class="btn payment"
      :disabled="loading"
      @click="downloadPayment"
    >excel download </button>
  </div>
</template>
-->

<script>
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
/* eslint-disable no-await-in-loop */

import Configuration from '@/js/Configuration';
import js2excel from 'js2excel'; // https://github.com/dwqs/js2excel

export default {
  props: ['searchCondition'],
  data: () => ({
    pagination: {
      page: 1,
      total: 0,
      length: 1,
      perPage: 500,
    },
    loading: false,
  }),
  methods: {
    async getPaymentCount() {
      try {
        let countURL = `${Configuration.value(
          'CPAYMENT_ADDRESS',
        )}/api/v1/cpayment/payment/count`;
        if (this.searchCondition) {
          countURL += `?${this.searchCondition}`;
        }
        const count = await this.$http.get(countURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (count.status !== 200) {
          throw new Error(`Response status is "${count.status}"`);
        }
        if (count.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${count.data.resultCode}"`);
        }
        if (count.data.count < 1) {
          this.pagination.page = 1;
          this.pagination.total = 0;
          this.pagination.length = 1;
          this.loading = false;
          return;
        }

        this.pagination.total = count.data.count;
        this.pagination.length = Math.ceil(
          this.pagination.total / this.pagination.perPage,
        );
      } catch (e) {
        this.pagination.page = 1;
        this.pagination.total = 0;
        this.pagination.length = 1;
        this.loading = false;

        alert('정보를 가져오지 못했습니다.\n잠시후 다시 시도해주세요.');
        console.error(e);
      }
    },
    async getPaymentList() {
      const payList = [];
      try {
        let listURL = `${Configuration.value(
          'CPAYMENT_ADDRESS',
        )}/api/v1/cpayment/payment/list?page=${this.pagination.page}&limit=${
          this.pagination.perPage
        }&showAll=true`;
        if (this.searchCondition) {
          listURL += `&${this.searchCondition}`;
        }
        const list = await this.$http.get(listURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (list.status !== 200) {
          if (list.status === 204) {
            this.loading = false;
            return null;
          }

          throw new Error(`response status is "${list.status}"`);
        }
        if (list.data.resultCode !== '0000') {
          throw new Error(`resultcode is "${list.data.resultCode}"`);
        }

        for (let i = 0; i < list.data.payments.length; i++) {
          const p = list.data.payments[i];
          payList.push(p);
        }
      } catch (e) {
        this.loading = false;

        alert('정보를 가져오지 못했습니다.\n잠시후 다시 시도해주세요.');
        console.error(e);
      }
      return payList;
    },
    async promisePayment() {
      const list = [];
      const page = this.pagination.page;
      for (let i = 1; i <= this.pagination.length; i++) {
        this.pagination.page = i;
        const response = this.getPaymentList();
        if (response !== null) {
          list.push(response);
        }
      }
      this.pagination.page = page;
      return Promise.all(list);
    },
    async getPayment() {
      this.loading = true;
      const list = [];
      const response = await this.promisePayment();
      if (response !== null && response.length > 0) {
        for (let i = 0; i < response.length; i++) {
          if (response[i] !== null) {
            for (let j = 0; j < response[i].length; j++) {
              list.push(response[i][j]);
            }
          }
        }
      }

      this.loading = false;
      return list;
    },
    async downloadPayment() {
      try {
        await this.getPaymentCount();
        if (this.pagination.total === 0) {
          alert('다운로드할 내용이 없습니다.');
          this.$emit('downloaded');
          return;
        }
        const list = await this.getPayment();
        if (list.length === 0) {
          alert('다운로드할 내용이 없습니다.');
          this.$emit('downloaded');
          return;
        }

        const companyList = {};
        const payments = [];
        for (let i = 0; i < list.length; i++) {
          const p = list[i];

          const state = this.$getConstName('state', p.state);
          const paymentMode = this.$getConstName('paymentMode', p.paymentMode);
          const approveType = this.$getConstName('approveType', p.approveType);
          const approveResult = this.$getConstName('approveResult', p.approveResult);
          const pAt = p.paymentAt ? this.$moment(p.paymentAt).format('YYYY-MM-DD HH:mm:ss') : '-';
          const aAt = p.approveAt ? this.$moment(p.approveAt).format('YYYY-MM-DD HH:mm:ss') : '-';

          //
          let registrationNo = '';
          if (!companyList[p.companyID]) {
            const company = await this.$getCompany(p.companyID, false, false);
            if (company) {
              companyList[p.companyID] = company;
              registrationNo = company.registrationNo;
            }
          } else {
            registrationNo = companyList[p.companyID].registrationNo;
          }

          const payment = {
            사업자번호: registrationNo,
            회사이름: p.companyName,
            paymentID: p.paymentID,
            state: p.state,
            상태: state || '-',
            tokenID: p.tokenID,
            deviceID: p.deviceID,
            paymentAt: pAt,
            paymentMode: p.paymentMode,
            거래구분: paymentMode || '-',
            paymentPrice: parseInt(p.paymentPrice, 10),
            approveAt: aAt,
            approveType: p.approveType,
            거래형태: approveType || '-',
            approveResult: p.approveResult,
            처리결과: approveResult || '-',
            approvePrice: parseInt(p.approvePrice, 10),
            approveNo: p.approveNo,
            승인코드: p.resultCode,
            승인메시지: p.resultMsg,
            companyID: p.companyID,
            divisionID: p.divisionID,
            divisionName: p.divisionName,
            deviceOperatorID: p.deviceOperatorID,
            deviceOperatorName: p.deviceOperatorName,
            address: p.address,
            place: p.place,
          };
          // TODO payments.push(payment);

          if (p.paymentDetails && p.paymentDetails.length > 0) {
            for (let j = 0; j < p.paymentDetails.length; j++) {
              /* TODO
              const p1 = {
                paymentID: p.paymentID,
              };
              p1.productID = p.paymentDetails[j].productID;
              p1.productName = p.paymentDetails[j].productName;
              p1.productCount = parseInt(p.paymentDetails[j].productCount, 10);
              p1.salePrice = parseInt(p.paymentDetails[j].salePrice, 10);
              payments.push(p1);
              */
              const p1 = JSON.parse(JSON.stringify(payment));
              p1.productID = p.paymentDetails[j].productID;
              p1.productName = p.paymentDetails[j].productName;
              p1.productType = p.paymentDetails[j].productType;
              p1.productCount = parseInt(p.paymentDetails[j].productCount, 10);
              p1.salePrice = parseInt(p.paymentDetails[j].salePrice, 10);
              payments.push(p1);
            }
          } else {
            // TODO
            payments.push(payment);
          }
        }
        js2excel.json2excel({
          data: payments,
          name: 'cella-payment',
          formateDate: 'yyyy/mm/dd',
        });
      } catch (e) {
        console.error('downloadExcel error', e);
      }

      this.$emit('downloaded');

      /*
      // for webpack 3: dynamic import
      // webpackChunkName: "js2excel"
      import('js2excel').then(({ json2excel }) => {
        json2excel({
          data: this.list,
          name: this.downloadFileName,
          formateDate: 'dd/mm/yyyy',
        });
      }).catch((e) => {

      });
      */
    },
  },
};
</script>

<style scoped>
.download .btn {
  width: 100%;
  height: 56px;
  font-size: 12.8px;
  font-weight: bold;
  border-radius: 2px;
  cursor: pointer;
  transition: 0.2s;
}
.download .btn:disabled {
  background-color: #dedede !important;
  color: #ffffff !important;
  border: solid 1px #dedede !important;
  cursor: default;
}
.download .btn.payment {
  color: #ffffff;
  background-color: green;
}
.download .btn.payment:hover {
  background-color: rgb(1, 148, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/Download.vue